// pattern: imperative-shell
import { getToken, setToken } from "./storage";

/** Ensures user has entered a token. Shows prompt if not. Returns token. */
export function ensureAuth(): string {
	const existing = getToken();
	if (existing) return existing;

	const token = promptForToken();
	if (token) {
		setToken(token);
		return token;
	}

	// If they cancel, keep prompting (there's nothing to show without auth)
	return ensureAuth();
}

function promptForToken(): string | null {
	return window.prompt("Enter your garden diary password:");
}
